import React from 'react'
import { ContentLayout, Header, Container, Box, SpaceBetween } from '@cloudscape-design/components'
import { Chatbot } from '../components/chatbot/Chatbot'

const steps = [
  { number: '1', title: 'Choose Your Map Type', description: 'VFR sectionals, marine charts, trail maps, and more' },
  { number: '2', title: 'Pick Your Locations', description: 'Select the airports, stations, or trails you want to feature' },
  { number: '3', title: 'Design Your Map', description: 'Choose layout, colors, and customize your style' },
  { number: '4', title: 'Build or Order', description: 'Construct it yourself (DIY) or have us build it for you' },
]

const GettingStarted: React.FC = () => {
  return (
    <ContentLayout
      header={
        <Header
          variant="h1"
          description="Your personal guide to building a custom LED weather map"
        >
          Getting Started
        </Header>
      }
    >
      <SpaceBetween size="l">
        <Container>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
            {steps.map(step => (
              <div key={step.number} style={{ flex: 1, textAlign: 'center', padding: '8px 4px', minWidth: 0 }}>
                <div style={{
                  width: 32, height: 32, borderRadius: '50%',
                  backgroundColor: '#0972d3', color: '#fff',
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '14px', fontWeight: 700, marginBottom: 6
                }}>
                  {step.number}
                </div>
                <Box variant="h4" textAlign="center">{step.title}</Box>
                <Box variant="small" color="text-body-secondary" textAlign="center">{step.description}</Box>
              </div>
            ))}
          </div>
        </Container>

        <div style={{ maxWidth: '100%' }}>
          <Chatbot />
        </div>
      </SpaceBetween>
    </ContentLayout>
  )
}

export default GettingStarted
